<template>
  <v-container fluid>
    <v-dialog
      v-model="successAddToCart"
      persistent
      max-width="450"
      max-height="350"
      width="100%"
    >
      <v-card>
        <v-card-title class="headline justify-center">
          <v-img
            max-height="44"
            max-width="42"
            src="@/assets/check-green.png"
          ></v-img>
        </v-card-title>
        <v-card-text class="text-center"
          >Produk sudah berhasil di Tambahkan</v-card-text
        >
        <v-card-text class="text-center">
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize"
            small
            color="primary"
            elevation="0"
            @click="toDashboard"
          >
            Kembali ke Beranda
          </v-btn>
          <v-btn
            style="border-color: yellow"
            outlined
            class="text-capitalize ml-2"
            small
            text
            color="black"
            @click="toTransaction"
          >
            Lihat Semua Transaksi
          </v-btn>
          <!-- <v-btn
              style="border-color: yellow"
              outlined
              class="text-capitalize ml-2"
              small
              text
              color="black"
            >
              Lihat Draft
            </v-btn> -->
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="notifDialog" persistent max-width="350">
      <v-card>
        <v-card-title class="headline justify-center">
          <v-img
            max-height="44"
            max-width="42"
            src="@/assets/alert.jpg"
          ></v-img>
        </v-card-title>
        <v-card-text class="text-center">{{
          errorMessageCheckout
        }}</v-card-text>
        <v-card-text class="text-center">
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize ml-2"
            small
            color="primary"
            elevation="0"
            @click="closeDialog"
          >
            Mengerti
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12" class="container-content">
        <v-tabs
            grow
            @change="onTabChange"
            v-model="activeTransTab"
            style="border-radius: 18px"
            class="pa-4"
          >
          <v-tab href="#tab-NON_REWARD">
            Keranjang Payment</v-tab
          >
          <v-tab href="#tab-REWARD">
            Keranjang Reward</v-tab
          >

          <v-tab-item value="tab-NON_REWARD" class="mt-3">
            
            <div class="cart-page">
              <v-row>
                <v-col cols="12">
                  <h3>
                    {{
                      Object.keys(cartList).length > 0
                        ? `Total ${Object.keys(cartList).length} produk`
                        : `Tidak ada produk yang dibeli`
                    }}
                  </h3>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="7" xl="9">
                  <v-checkbox
                    color="error"
                    hide-details="auto"
                    label="Pilih Semua Produk"
                    @change="checklistAllProduct"
                    v-model="checkboxSelectNonReward"
                  ></v-checkbox>
                  <v-row>
                    <v-col
                      cols="12"
                      v-for="(item, itemId) in cartList"
                      :key="itemId"
                    >
                      <v-card flex-direction: row elevation="1" outlined style="background: #FFF7F9; border-radius: 8px;">
                        <template>
                          <div class="cart-item">
                            <router-link
                              class="success--text text-decoration-none"
                              :to="`/product/${item.productCode}/nonreward/detail`"
                            >
                              <div class="cart-item--thumb">
                                <v-img
                                  :src="`data:image/png;base64,${item.iconSmall}`"
                                  max-width="60"
                                  lazy-src="@/assets/empty-img.png"
                                  contain
                                ></v-img>
                              </div>
                            </router-link>
                            <div class="cart-item--body">
                              <v-list-item three-line class="pa-0">
                                <v-list-item-content>
                                  <v-list-item-title style="white-space: normal; word-wrap: break-word;">
                                    {{ item.productName }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{ item.personName }}
                                  </v-list-item-subtitle>
                                  <v-list-item-subtitle>
                                    {{ item.oid }}
                                  </v-list-item-subtitle>
                                  <v-list-item-subtitle
                                    v-if="
                                      item.totalDiscount != null &&
                                        item.totalDiscount != ''
                                    "
                                  >
                                    <span
                                      style="color: black; text-decoration: line-through;"
                                      >Rp {{ humanFormat(item.priceProduct) }}</span
                                    >
                                    <span style="color: crimson;">
                                      {{ item.price }}
                                    </span>
                                    <span
                                      style="padding: 4px; background: pink; border-radius: 33px;"
                                    >
                                      {{ item.totalDiscount }} Disc
                                    </span>
                                  </v-list-item-subtitle>
                                  <v-list-item-subtitle
                                    v-else
                                    style="color: crimson;"
                                  >
                                    Rp. {{ humanFormat(item.priceProduct) }}
                                  </v-list-item-subtitle>

                                  <v-list-item-subtitle>
                                    <span
                                      style="
                                        color: black;
                                        font-size: 12px;
                                        font-weight: 300;
                                        line-height: 20px;
                                      "
                                    >
                                      <strong>Quantity</strong>
                                    </span>

                                    <input
                                      type="number"
                                      v-model.number="item.quantity"
                                      class="inputQty"
                                      @keypress="numOnly"
                                      @input="handleCheckPrice(item, itemId)"
                                      style="text-align: right; border-color: black; border-style: solid; border-radius: 8px; margin-left: 8px;"
                                    />

                                    <v-btn
                                      @click="addQuantity(item, itemId)"
                                      density="compact"
                                      style="background-color: black; margin-left: 5px; 
                                        min-width: 0px; width: 10px; height: 30px;"
                                    >
                                      <v-icon color="white">mdi-plus</v-icon>
                                    </v-btn>
                                    <v-btn
                                      @click="removeQuantity(item, itemId)"
                                      density="compact"
                                      style="background-color: black; margin-left: 5px;
                                        min-width: 0px; width: 10px; height: 30px;"
                                    >
                                      <v-icon color="white">mdi-minus</v-icon>
                                    </v-btn>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </div>
                            <div class="cart-item--action">
                              <v-checkbox
                                ref="n"
                                v-model="checkoutItem"
                                :value="itemId"
                                @change="checkboxValidation(item)"
                                color="yellow"
                                hide-details="auto"
                                class="cart-item--action-check"
                              ></v-checkbox>
                              <ul class="action-cart-item">
                                <li>
                                  <v-btn
                                    block
                                    text
                                    @click="confirmRemoveItem(itemId, 'CIS_NEW')"
                                  >
                                    <v-icon style="font-size: 20px"
                                      >mdi-trash-can</v-icon
                                    >
                                  </v-btn>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </template>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <template v-if="Object.keys(cartList).length > 0">
                  <v-col cols="12" sm="12" md="12" lg="5" xl="3">
                    <div class="sumTotal">
                      <div class="d-flex justify-space-between">
                        <p class="font-weight-medium">Subtotal + PPN <span>{{ this.ppn }}</span></p>
                        <p class="pinkText">{{ this.totalHarusBayar }}</p>
                      </div>
                      <v-btn @click="goToAddOrder()"
                      :disabled="this.disableBtnPayment" class="btnCheckout">pesan</v-btn>
                    </div>
                  </v-col>
                </template>
              </v-row>
          
            </div>
          </v-tab-item>

          <v-tab-item value="tab-REWARD" class="mt-3">
            <div class="cart-page">
              <v-row>
                <v-col cols="12">
                  <h3>
                    {{
                      Object.keys(cartListReward).length > 0
                        ? `Total ${Object.keys(cartListReward).length} produk`
                        : `Tidak ada produk yang dibeli`
                    }}
                  </h3>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="7" xl="9">
                  <v-checkbox
                    color="error"
                    hide-details="auto"
                    label="Pilih Semua Produk"
                    @change="checklistAllProductReward"
                    v-model="checkboxSelectReward"
                  ></v-checkbox>
                  <v-row>
                    <v-col
                      cols="12"
                      v-for="(item, itemId) in cartListReward"
                      :key="itemId"
                    >
                      <v-card flex-direction: row elevation="1" outlined style="background: #FFF7F9; border-radius: 8px;">
                        <template>
                          <div class="cart-item">
                            <router-link
                              class="success--text text-decoration-none"
                              :to="`/product/${item.productCode}/${$constant.REWARD}/detail`"
                            >
                              <div class="cart-item--thumb">
                                <v-img
                                  :src="`data:image/png;base64,${item.iconSmall}`"
                                  max-width="60"
                                  lazy-src="@/assets/empty-img.png"
                                  contain
                                ></v-img>
                              </div>
                            </router-link>
                            <div class="cart-item--body">
                              <v-list-item three-line class="pa-0">
                                <v-list-item-content>
                                  <v-list-item-title style="white-space: normal; word-wrap: break-word;">
                                    {{ item.productName }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{ item.personName }}
                                  </v-list-item-subtitle>
                                  <v-list-item-subtitle>
                                    {{ item.oid }}
                                  </v-list-item-subtitle>
                                  <v-list-item-subtitle>
                                    <div class="d-flex flex-row">
                                      <v-img
                                          max-height="15"
                                          max-width="15"
                                          src="@/assets/icon-color-coin.svg"
                                      ></v-img>
                                      <span class="ml-1" style="color: #FFA800;">{{ item.pointChange}} Poin</span>
                                    </div>
                                  </v-list-item-subtitle>

                                  <v-list-item-subtitle>
                                    <span
                                      style="
                                        color: black;
                                        font-size: 12px;
                                        font-weight: 300;
                                        line-height: 20px;
                                      "
                                    >
                                      <strong>Quantity</strong>
                                    </span>

                                    <input
                                      type="number"
                                      v-model.number="item.quantity"
                                      @keypress="numOnly"
                                      @input="handleCheckPriceReward(item, itemId)"
                                      style="text-align: right; border-color: black; border-style: solid; border-radius: 8px; margin-left: 8px;"
                                    />

                                    <v-btn
                                      @click="addQuantityReward(item, itemId)"
                                      density="compact"
                                      style="background-color: black; margin-left: 5px; 
                                        min-width: 0px; width: 10px; height: 30px;"
                                    >
                                      <v-icon color="white">mdi-plus</v-icon>
                                    </v-btn>
                                    <v-btn
                                      @click="removeQuantityReward(item, itemId)"
                                      density="compact"
                                      style="background-color: black; margin-left: 5px;
                                        min-width: 0px; width: 10px; height: 30px;"
                                    >
                                      <v-icon color="white">mdi-minus</v-icon>
                                    </v-btn>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </div>
                            <div class="cart-item--action">
                              <v-checkbox
                                ref="n"
                                v-model="checkoutItemReward"
                                :value="itemId"
                                @change="checkboxValidationReward(item)"
                                color="yellow"
                                hide-details="auto"
                                class="cart-item--action-check"
                              ></v-checkbox>
                              <ul class="action-cart-item">
                                <li>
                                  <v-btn
                                    block
                                    text
                                    @click="confirmRemoveItem(itemId, 'CIS_REWARD')"
                                  >
                                    <v-icon style="font-size: 20px"
                                      >mdi-trash-can</v-icon
                                    >
                                  </v-btn>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </template>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <template v-if="Object.keys(cartListReward).length > 0">
                  <v-col cols="12" sm="12" md="12" lg="5" xl="3">
                    <div class="sumTotal">
                      <div class="d-flex justify-space-between">
                        <p class="font-weight-medium">Total Point</p>
                        <div class="d-flex flex-row">
                          <v-img
                              max-height="20"
                              max-width="20"
                              src="@/assets/icon-color-coin.svg"
                          ></v-img>
                          <span class="ml-1" style="color: #FFA800;">{{ this.totalPoinChange}} Poin</span>
                        </div>
                      </div>
                      <div class="d-flex justify-space-between">
                        <p class="font-weight-medium">M - Point kamu</p>
                        <div class="d-flex flex-row">
                          <v-img
                              max-height="20"
                              max-width="20"
                              src="@/assets/icon-color-coin.svg"
                          ></v-img>
                          <span class="ml-1" style="color: #FFA800;">{{ this.userPoint}} Poin</span>
                        </div>
                      </div>
                      <v-btn @click="goToAddOrder()"
                      :disabled="this.disableBtnPaymentReward" class="btnCheckout">pesan</v-btn>
                    </div>
                  </v-col>
                </template>
              </v-row>
          
            </div>
          </v-tab-item>

        </v-tabs>
      </v-col>
    </v-row>
    
    <v-dialog v-model="dialogRemoveItem" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"> Yakin untuk hapus? </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogRemoveItem = false">
            Tidak
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="removeItem(itemIdWillRemove, statusCart)"
          >
            Ya
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogQtyEmpty" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"> Quantity tidak boleh kosong atau 0 </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogQtyEmpty = !dialogQtyEmpty">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      dialogStokConfirmation: false,
      dialogQtyEmpty: false,
      totalPoinChange: 0,
      errorMessageCheckout: "",
      disableBtnPayment: true,
      disableBtnPaymentReward: true,
      activeTransTab: null,
      statusCart: "",
      selectAll: false, //SELECT ALL
      checkoutItemProductCode: [],
      exists: null,
      loading: false,
      pageSize: 100,
      activeCartTab: null,
      dialogRemoveItem: false,
      // loading: false,
      checkoutItem: [],
      checkoutItemReward: [],
      itemIdWillRemove: "",
      totalPembelian: 0,
      totalBiayaAdmin: 0,
      totalHarusBayar: 0,
      totalPromo: 0,
      totalPriceOriginal: 0,
      firstUrlToPreview: "",
      button: false,
      notifDialog: false,
      jumlahHalaman: 0,
      totalDataCartNew: 0,
      totalDataCartDraft: 0,
      successAddToCart: false,
      ppn: "-",
      userPoint: 0,
      cartList:[],
      cartListReward:[],
      checkboxSelectNonReward: false,
      checkboxSelectReward: false,
    };
  },
  props: ['cartStatus'],
  methods: {
    ...mapActions([
      "changeTitleApp",
      "getCartListReward",
      "checkoutCart",
      "deleteFromCart",
      "getCartList",
      "getInquiryPromo",
      "refreshToken",
      "addOrder",
      "checkoutCartReward",
      "getProfile"
    ]),
    handleNoEnter: function(e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        e.preventDefault();
        return false;
      }
    },
    goToAddOrder() {
      if (this.activeTransTab == 'tab-NON_REWARD') {
        this.$store.state.checkboxItemDetail = [];

        this.checkoutItem.forEach((item) => {
          this.$store.state.checkboxItemDetail.push({
            internalId: this.cartList[item].internalId,
            quantity: this.cartList[item].quantity,
            username: this.cartList[item].username,
            productCode: this.cartList[item].productCode,
            productName: this.cartList[item].productName,
            price: this.cartList[item].price,
            iconSmall: this.cartList[item].iconSmall,
            oid: this.cartList[item].oid,
            totalDiscount: this.cartList[item].totalDiscount,
            priceProduct: this.cartList[item].priceProduct,
            shoppingDate: this.cartList[item].shoppingDate,
          });
        });

        this.$router.push(`/purchase-detailsNew/nonreward`);
      } else {
        this.$store.state.checkboxItemDetail = [];

        this.checkoutItemReward.forEach((item) => {
          this.$store.state.checkboxItemDetail.push({
            internalId: this.cartListReward[item].internalId,
            quantity: this.cartListReward[item].quantity,
            username: this.cartListReward[item].username,
            productCode: this.cartListReward[item].productCode,
            productName: this.cartListReward[item].productName,
            price: this.cartListReward[item].price,
            iconSmall: this.cartListReward[item].iconSmall,
            oid: this.cartListReward[item].oid,
            totalDiscount: this.cartListReward[item].totalDiscount,
            priceProduct: this.cartListReward[item].priceProduct,
            shoppingDate: this.cartListReward[item].shoppingDate,
            pointChange: this.cartListReward[item].pointChange,
            totalPointChange: this.cartListReward[item].totalPointChange,
          });
        });

        this.$router.push(`/purchase-detailsNew/${this.$constant.REWARD}`);
      }
      
    },
    checkboxValidation(item){
      if (item.quantity == '' || item.quantity == 0) {
        item.quantity = 1;

        this.handleCheckout();
      }else{

        this.handleCheckout();
      }
    },
    checkboxValidationReward(item){
      if (item.quantity == '' || item.quantity == 0) {
        item.quantity = 1;

        this.handleCheckoutReward();
      }else{

        this.handleCheckoutReward();
      }
    },
    handleCheckPrice: function(item, itemId) {
      //HITUNG HARGA JIKA SUDAH DI CEKLIS ITEMNYA
      if (item.quantity != '' && item.quantity != 0) {
        if (
          this.checkoutItem.length > 0 &&
          this.checkoutItem.includes(itemId)
        ) {
          this.handleCheckout();
        }
      }else{
        if (this.checkoutItem.includes(itemId)) {
          this.checkoutItem = this.checkoutItem.filter((e) => e !== item.internalId)

          this.handleCheckout();
        }
        
      }
    },
    handleCheckPriceReward: function(item, itemId) {
      //HITUNG HARGA JIKA SUDAH DI CEKLIS ITEMNYA
      if (item.quantity != '' && item.quantity != 0) {
        if (
          this.checkoutItemReward.length > 0 &&
          this.checkoutItemReward.includes(itemId)
        ) {
          this.handleCheckoutReward();
        }
      }else{
        if (this.checkoutItemReward.includes(itemId)) {
          this.checkoutItemReward = this.checkoutItemReward.filter((e) => e !== itemId)

          this.handleCheckoutReward();
        }
        
      }
    },
    onTabChange: function(
      clickedTab //udah dipanggil di layout
    ) {
      switch (clickedTab) {
        case "tab-NON_REWARD":
          this.load("CIS_NEW");
          break;
        case "tab-REWARD":
          this.getCartListReward({
            pageNumber: 1,
            pageSize: 100,
            searchVal: "",
            status: "CIS_NEW",
          }).then((response) => {
            const items = response?.data?.data?.listData || [];

            this.cartListReward = items.map((item) => ({
              productCode: item.productCode,
              iconSmall: item.iconSmall,
              productName: item.productName,
              oid: item.oid,
              totalDiscount: item.totalDiscount,
              priceProduct: item.priceProduct,
              price: item.price,
              personName: item.personName,
              quantity: item.quantity,
              pointChange: item.pointChange,
              shoppingDate: item.shoppingDate,
              internalId: item.internalId,
            }));
          });
          break;
      }
    },
    addQuantity(item, itemId) {
      if (item.quantity != '') {
        let numberQty = parseInt(item.quantity) + 1;
        item.quantity = numberQty;
      } else {
        item.quantity = 1;

      }

      //HITUNG HARGA JIKA SUDAH DI CEKLIS ITEMNYA
      if (
        this.checkoutItem.length > 0 &&
        this.checkoutItem.includes(itemId)
      ) {
        this.handleCheckout();
      }
    },
    addQuantityReward(item, itemId) {
      if (item.quantity != '') {
        let numberQty = parseInt(item.quantity) + 1;
        item.quantity = numberQty;
      } else {
        item.quantity = 1;
      }
  
      //HITUNG HARGA JIKA SUDAH DI CEKLIS ITEMNYA
      if (
        this.checkoutItemReward.length > 0 &&
        this.checkoutItemReward.includes(itemId)
      ) {
        this.handleCheckoutReward();
      }
    },
    removeQuantity(item, itemId) {
      if (item.quantity > 1) {
        item.quantity -= 1;

        //HITUNG HARGA JIKA SUDAH DI CEKLIS ITEMNYA
        if (
          this.checkoutItem.length > 0 &&
          this.checkoutItem.includes(itemId)
        ) {
          this.handleCheckout();
        }
      }
    },
    removeQuantityReward(item, itemId) {
      if (item.quantity > 1) {
        item.quantity -= 1;

        //HITUNG HARGA JIKA SUDAH DI CEKLIS ITEMNYA
        if (
          this.checkoutItemReward.length > 0 &&
          this.checkoutItemReward.includes(itemId)
        ) {
          this.handleCheckoutReward();
        }
      }
    },
    handleCheckoutAll(e) {
      //SELECT ALL
      if (e == true) {
        // this.$refs.n.forEach((val, index) => {
        // console.log("tapi perang", val.value, index);
        let checkboxItems = this.$refs.n.map(function(val) {
          return { internalId: val.value };
        });
        let checkoutItems = {};
        this.$refs.n.forEach((val, idxItem) => {
          this.checkoutItem.push(val.value);
          if (this.cartList[val.value]) {
            checkoutItems[val.value] = this.cartList[val.value]; //cek ini apakah perlu dispatch untuk ngambil item produk ?
          } else {
            this.checkoutItem.splice(idxItem, 1); //unset undefined checkout items
          }
        });
        this.checkoutCart({
          listCartItemId: [...checkboxItems],
          checkoutItems: checkoutItems,
          programId: this.promoChosen ? this.promoChosen : "",
        })
          .then((response) => {
            return this.$helpers.handleSuccess(response);
          })
          .then((response) => {
            this.button = true;
            this.totalPembelian = response.totalPrice;
            this.totalBiayaAdmin = response.totalAdminFeeAmt;
            this.totalHarusBayar = response.totalToBePaid;
            this.ppn = response.ppn;
            console.log("-=-=-= " + response.ppn);
          })
          .catch((err) => {
            this.button = false;
            this.totalPembelian = 0;
            this.totalBiayaAdmin = 0;
            this.totalHarusBayar = 0;
            this.$store.state.checkoutSum = 0;
            this.$store.state.adminFee = 0;
            this.$store.state.totalToBePaid = 0;
            this.$store.state.promoTotal = 0;
            this.$store.state.promoChosen = "";
            this.$store.state.promoChosenCode = "";
            this.$store.state.promoChosenName = "";
            this.selectAll = false;
            this.$helpers.handleError(err);
          });
        // console.log("BISMILLAH", this.firstUrlToPreview);
        // });
      } else {
        this.button = false;
        this.totalPembelian = 0;
        this.totalBiayaAdmin = 0;
        this.totalHarusBayar = 0;
        this.$store.state.checkoutSum = 0;
        this.$store.state.adminFee = 0;
        this.$store.state.totalToBePaid = 0;
        this.$store.state.promoTotal = 0;
        this.$store.state.promoChosen = "";
        this.$store.state.promoChosenCode = "";
        this.$store.state.promoChosenName = "";
        this.checkoutItem = [];
      }
    },
    alertTest() {
      this.$router.push(`/promo/add`);
    },
    load(status) {
      this.refreshToken().then(() => {
        this.getCartList({
          by: {
            pageNumber: 1,
            pageSize: 100,
            searchVal: "",
            status: status,
          },
          isGroupedByStatus: true,
        })
          .then((response) => {
            this.$helpers.handleSuccess(response);

            console.log("ini resp cart ya ")
            console.log(response)

            const items = response?.data?.data?.listData || [];

            this.cartList = items.map((item) => ({
              productCode: item.productCode,
              iconSmall: item.iconSmall,
              productName: item.productName,
              oid: item.oid,
              totalDiscount: item.totalDiscount,
              priceProduct: item.priceProduct,
              price: item.price,
              personName: item.personName,
              quantity: item.quantity,
              pointChange: item.pointChange,
              shoppingDate: item.shoppingDate,
              internalId: item.internalId
            }));
          })
          .catch((error) => {
            this.$helpers.handleError(error);
          });
      });

      if (this.totalDataCartNew !== 0) {
        this.jumlahHalaman = Math.ceil(this.totalDataCartNew / this.pageSize) - 1;
      } else {
        this.jumlahHalaman = Math.ceil(1 / this.pageSize) - 1;
      }
    },
    nextPage() {
      if (this.jumlahHalaman > 0) {
        this.pageSize += 100;

        this.refreshToken().then(() => {
          this.getCartList({
            by: {
              pageNumber: 1,
              pageSize: this.pageSize,
              searchVal: "",
              status: "",
            },
            isGroupedByStatus: true,
          })
            .then((response) => {
              console.log("ini resp cart ya ")
            console.log(response)

              const items = response?.data?.data?.listData || [];

              this.cartList = items.map((item) => ({
                productCode: item.productCode,
                iconSmall: item.iconSmall,
                productName: item.productName,
                oid: item.oid,
                totalDiscount: item.totalDiscount,
                priceProduct: item.priceProduct,
                price: item.price,
                personName: item.personName,
                quantity: item.quantity,
                pointChange: item.pointChange,
                shoppingDate: item.shoppingDate,
                internalId: item.internalId
              }));
            })
            .catch((error) => {
              this.$helpers.handleError(error);
            });
        });

        this.jumlahHalaman--;
      }
    },
    loadCartList() {
      this.refreshToken().then(() => {
        this.getCartList({
          by: {
            pageNumber: 1,
            pageSize: 1000,
            searchVal: "",
            status: "CIS_NEW",
          },
          isGroupedByStatus: true,
        })
          .then((response) => {
            this.totalDataCartNew = response.data.countData;
            this.$helpers.handleSuccess(response);
          })
          .catch((error) => {
            this.$helpers.handleError(error);
          });
      });
    },
    closeDialog() {
      this.notifDialog = false;
      // window.location.reload();
    },

    toDashboard() {
      this.successAddToCart = false;
      this.$router.push(`/dashboard`);
    },
    toTransaction() {
      this.successAddToCart = false;
      this.$router.push(`/transactions`);
    },

    validateInput($event, item){
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57)) {
        // 46 is dot
        $event.preventDefault();
      }
      if (item.quantity == 0) {
        item.quantity = 1;
      }
    },
    checklistAllProduct(){
      if (this.checkboxSelectNonReward == true) {
        this.checkoutItem = [];
        this.checkoutItem = this.cartList.map((_, i) => i);

        this.handleCheckout();
      } else {
        if (this.checkoutItem.length > 0) {
          this.checkoutItem = [];
          this.handleCheckout();
        }
        
      }

    },
    checklistAllProductReward(){
      if (this.checkboxSelectReward == true) {
        this.checkoutItemReward = [];
        this.checkoutItemReward = this.cartListReward.map((_, i) => i);

        this.handleCheckoutReward();
      } else {
        if (this.checkoutItemReward.length > 0) {
          this.checkoutItemReward = [];
          this.handleCheckoutReward();
        }
        
      }
    },
    handleCheckout() {
      //enable button payment
      if (this.checkoutItem.length > 0) {
        this.disableBtnPayment = false;
      } else {
        this.disableBtnPayment = true;
      }

      let checkOutItemWithQty = [];
      this.checkoutItem.forEach((item) => {
        const cart = this.cartList[item];
        if (cart) {
          checkOutItemWithQty.push({
            internalId: cart.internalId,
            quantity: cart.quantity,
          });
        } else {
          console.warn(`Item ${item} tidak ditemukan di cartList.`);
        }
      });

      //PENANDA CHECKBOX SUDAH TER CEKLIS SEBELUMNYA
      this.$store.state.checkboxItemsChosen = this.checkoutItem;

      if (checkOutItemWithQty.length > 0) {
        this.$store.state.checkboxItemsChosenDetail = [...checkOutItemWithQty];
        this.refreshToken().then(() => {
          this.checkoutCart({
            listCartItemId: [...checkOutItemWithQty],
            // checkoutItems: checkoutItems,
            programId: this.promoChosen ? this.promoChosen : "",
          })
            .then((response) => {
              return this.$helpers.handleSuccess(response);
            })
            .then((response) => {
              this.button = true;
              this.totalPembelian = response.totalPrice;
              this.totalBiayaAdmin = response.totalAdminFeeAmt;
              this.totalHarusBayar = response.totalToBePaid;
              this.totalPromo = response.totalPromo;
              this.totalPriceOriginal = response.totalPriceOriginal;
              this.ppn = response.ppn;
            })
            .catch((err) => {
              if (err.response) {
                this.errorMessageCheckout = err.response.data.message;
                this.notifDialog = true;

                this.checkoutItem = [];
              }
              this.button = false;
              this.totalPembelian = 0;
              this.totalBiayaAdmin = 0;
              this.totalHarusBayar = 0;
              this.$store.state.checkoutSum = 0;
              this.$store.state.adminFee = 0;
              this.$store.state.totalToBePaid = 0;
              this.$store.state.promoTotal = 0;
              this.$store.state.promoChosen = "";
              this.$store.state.promoChosenCode = "";
              this.$store.state.promoChosenName = "";
              this.$helpers.handleError(err);
            });
        });
      } else {
        this.button = false;
        this.totalPembelian = 0;
        this.totalBiayaAdmin = 0;
        this.totalHarusBayar = 0;
        this.$store.state.checkoutSum = 0;
        this.$store.state.adminFee = 0;
        this.$store.state.totalToBePaid = 0;
        this.$store.state.promoTotal = 0;
        this.$store.state.promoChosen = "";
        this.$store.state.promoChosenCode = "";
        this.$store.state.promoChosenName = "";
      }

    },
    handleCheckoutReward() {
      //enable button payment
      if (this.checkoutItemReward.length > 0) {
        this.disableBtnPaymentReward = false;
      } else {
        this.disableBtnPaymentReward = true;
      }

      let checkOutItemWithQtyReward = [];

      this.checkoutItemReward.forEach((item) => {

        checkOutItemWithQtyReward.push({
          chartItemRewardId: this.cartListReward[item].internalId,
          quantity: this.cartListReward[item].quantity,
        });
      });

      //PENANDA CHECKBOX SUDAH TER CEKLIS SEBELUMNYA
      this.$store.state.checkboxItemsChosenReward = this.checkoutItemReward;

      if (checkOutItemWithQtyReward.length > 0) {
        this.$store.state.checkboxItemsChosenDetail = [...checkOutItemWithQtyReward];
        this.refreshToken().then(() => {
          this.checkoutCartReward({
            listCartItemId: [...checkOutItemWithQtyReward],
          })
            .then((response) => {
              return this.$helpers.handleSuccess(response);
            })
            .then((response) => {
              this.totalPoinChange = response.totalPointChange;

              // cek user point harus lebih besar dari poin belanja
              if (this.userPoint >= this.totalPoinChange) {
                console.log(this.totalPoinChange)
                this.disableBtnPaymentReward = false;
              }else{
                this.disableBtnPaymentReward = true;
              }
            })
            .catch((err) => {
              if (err.response) {
                this.errorMessageCheckout = err.response.data.message;
                this.notifDialog = true;

                this.checkoutItemReward = []
              }
              this.totalPoinChange = 0;
              this.button = false;
              this.totalPembelian = 0;
              this.totalBiayaAdmin = 0;
              this.totalHarusBayar = 0;
              this.$store.state.checkoutSum = 0;
              this.$store.state.adminFee = 0;
              this.$store.state.totalToBePaid = 0;
              this.$store.state.promoTotal = 0;
              this.$store.state.promoChosen = "";
              this.$store.state.promoChosenCode = "";
              this.$store.state.promoChosenName = "";

              this.disableBtnPaymentReward = true;
              
              this.$helpers.handleError(err);
            });
        });
      } else {
        this.button = false;
        this.totalPembelian = 0;
        this.totalBiayaAdmin = 0;
        this.totalPoinChange = 0;
        this.$store.state.checkoutSum = 0;
        this.$store.state.adminFee = 0;
        this.$store.state.totalToBePaid = 0;
        this.$store.state.promoTotal = 0;
        this.$store.state.promoChosen = "";
        this.$store.state.promoChosenCode = "";
        this.$store.state.promoChosenName = "";
      }
    },
    confirmRemoveItem(itemId, status) {
      //update arif 24-06-2025
      if (status == 'CIS_NEW') {
        this.itemIdWillRemove = this.cartList[itemId].internalId;
      }else{
        this.itemIdWillRemove = this.cartListReward[itemId].internalId;
      }
      
      this.dialogRemoveItem = true;
      this.statusCart = status;
    },
    removeItem(itemId, status) {
      if (status == 'CIS_NEW') {
        this.checkoutItem = this.checkoutItem.filter(function(item) {
          return item != itemId;
        })

        this.deleteFromCart({
        internalId: itemId,
        })
        .then((response) => {
          this.handleCheckout();
          this.load('CIS_NEW');

          this.dialogRemoveItem = false;
          return this.$helpers.handleSuccess(response);
        })
        
      } else {

        this.checkoutItemReward = this.checkoutItemReward.filter(function(item) {
          return item !== itemId;
        })

        this.deleteFromCart({
          internalId: this.cartListReward[itemId].internalId,
        })
        .then((response) => {
          this.handleCheckoutReward();
          this.getCartListReward({
            pageNumber: 1,
            pageSize: 100,
            searchVal: "",
            status: "CIS_NEW",
          }).then((response) => {
            const items = response?.data?.data?.listData || [];

            this.cartListReward = items.map((item) => ({
              productCode: item.productCode,
              productName: item.productName,
              oid: item.oid,
              totalDiscount: item.totalDiscount,
              priceProduct: item.priceProduct,
              price: item.price,
              personName: item.personName,
              quantity: item.quantity,
              pointChange: item.pointChange,
              shoppingDate: item.shoppingDate,
              internalId: item.internalId,
              iconSmall: item.iconSmall
            }));
          });

          this.dialogRemoveItem = false;
          return this.$helpers.handleSuccess(response);
        })
     
      }
    },

    loadUserPoint(){
      this.getProfile().then((resp) => {
        this.userPoint = resp.data.data.poin;
      });
    }
  },
  created() {
    this.changeTitleApp("Keranjang");
  },
  mounted() {
    console.log(this.cartStatus);
    this.loadUserPoint();
    this.checkoutItem = [];
    if (this.cartStatus == this.$constant.REWARD) {
      this.activeTransTab = `tab-REWARD`;
    }else{
      this.activeTransTab = `tab-NON_REWARD`;
    }
    
  },
  computed: {
    ...mapState([
      "checkboxItemDetail",
      "products",
      "checkoutItems",
      "checkoutSum",
      "promoList",
      "adminFee",
      "totalToBePaid",
      "promoTotal",
      "checkboxItemsChosenQty",
      "checkboxItemsChosen",
      "promoChosen",
      "promoChosenCode",
      "promoChosenName",
      "checkboxItemsChosenDetail",
      "checkboxItemsChosenDetailPromo",
    ]),
    // jumlahHalaman() {
    //   return Math.ceil(this.cartNewIds.length / this.pageSize);
    // },
    // cartNewAll() {
    //   return this.cartList;
    // },
    cartNewIds() {
      return Object.keys(this.cartList);
    },
    checkoutItemIds() {
      return Object.keys(this.checkoutItems);
    },
    totalPembelianView() {
      return this.humanFormat(this.totalPembelian);
    },
    totalBiayaAdminView() {
      return this.humanFormat(this.totalBiayaAdmin);
    },
    totalHarusBayarView() {
      return this.humanFormat(
        this.totalHarusBayar < 0 ? 0 : this.totalHarusBayar
      );
    },
  },
};
</script>

// <style src="./Cart.scss" lang="scss" />
